'use client'

import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipTrigger,
} from '@radix-ui/react-tooltip'

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/tooltip#provider}
 */
export const TooltipPrimitiveProvider = TooltipProvider

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/tooltip#root}
 */
export const TooltipPrimitive = Tooltip

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/tooltip#trigger}
 */
export const TooltipPrimitiveTrigger = TooltipTrigger

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/tooltip#portal}
 */
export const TooltipPrimitivePortal = TooltipPortal

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/tooltip#content}
 */
export const TooltipPrimitiveContent = TooltipContent

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/tooltip#arrow}
 */
export const TooltipPrimitiveArrow = TooltipArrow
